import React, { useContext, useState, useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import AppContext from '../../../App/AppContext';
import { SecondaryButton, PrimaryButton } from '../../../Core/FormInput';
import Box from '@material-ui/core/Box';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton } from '@material-ui/core';
import { DeleteWebForm } from './../../../Core/Service/webForm-service';
import Typography from '@material-ui/core/Typography';
import { deleteDynamicForm } from '../../../Core/Service/dynamic-forms-service';

const DeleteDynamicForm = (props) => {
    const { showToast } = useContext(AppContext);

    const handleClose = () => {
        props.onClose(false);
    };

    const handleDelete = async () => {
        let res = await deleteDynamicForm(props.recordId);
        if (!res.success) {
            console.error(res);
        } else {
            props.onClose(true);
        }
        showToast(res.message);
    };

    return (
        <Dialog open={true} onClose={handleClose} maxWidth="md">
            <Box display="flex" alignItems="center">
                <Box flexGrow={1}>
                    <DialogTitle>Delete Dynamic Form - {props.dynamicFormName}</DialogTitle>
                </Box>
                <Box>
                    <IconButton onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
            </Box>
            <DialogContent style={{ width: '600px', height: '50px' }}>
                <Typography variant="h6" display="block" gutterBottom>
                    Are you sure to delete this dynamic form
                </Typography>
            </DialogContent>
            <DialogActions>
                <SecondaryButton className="Submitbtn" onClick={handleClose}>
                    No
                </SecondaryButton>
                <PrimaryButton className="Submitbtn" onClick={handleDelete}>
                    Yes
                </PrimaryButton>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteDynamicForm;
